import { memo } from 'react';

import ArchiveIconSVG from '@/assets/archive-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IArchiveIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ArchiveIconSVG} {...props} />;

export const ArchiveIcon = memo(IArchiveIcon) as typeof IArchiveIcon;
